const storeNamePrefix = 'hiddenItems-';

export const getStoreName = formStoreName => `${storeNamePrefix}${formStoreName}`;
